import { render, staticRenderFns } from "./slider-item-image.vue?vue&type=template&id=a725b64a&scoped=true"
import script from "./slider-item-image.vue?vue&type=script&lang=js"
export * from "./slider-item-image.vue?vue&type=script&lang=js"
import style0 from "./slider-item-image.vue?vue&type=style&index=0&id=a725b64a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a725b64a",
  null
  
)

export default component.exports